import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  API_ROUTE_V2_PREFIX,
  IPageRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { LOB, PARTNER } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getLandingPageDetails = async (reqData: IPageRequestParams) => {
  const { partner, headers, cmp, query, dvid } = reqData;
  const headerCmp = resolveCmpForApiRequest(cmp, query);
  const { type } = query || {};

  const params = {
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    ...query,
  };

  const urlParams = setURLQueryParams(params);
  if (type) {
    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_GENERIC_PATH}/${type}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp, dvid },
      }
    );
    return response;
  } else if (partner === PARTNER.MYPARTNER) {
    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${API_ROUTES.GET_LANDING_PAGE_DETAILS_MY_PARTNER}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp, dvid },
      }
    );
    return response;
  } else if (partner === PARTNER.MYBIZ) {
    const response = await API_HTTP.get(
      `${API_ROUTE_V2_PREFIX}/mmt/${API_ROUTES.GET_LANDING_PAGE_DETAILS}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp || "fallback", dvid },
      }
    );
    return response;
  } else {
    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_LANDING_PAGE_DETAILS}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp || "fallback", dvid },
      }
    );
    return response;
  }
};
